module.exports = __webpack_public_path__ + "static/asg-logo-9e5caa996be702c4fbb6b5b365e1ce90.png";